import type {IModelDto} from "./model.dto";

export class Model implements IModelDto {

    //---------------------------------
    // Public Methods
    //---------------------------------

    public mapFromDto(modelDto: IModelDto): void {
        for (const key in modelDto) {
            if (Object.prototype.hasOwnProperty.call(modelDto, key)) {
                const value: any = (modelDto as any)[key];
                if (value !== null && value !== undefined) {
                    (this as any)[key] = value;
                }
            }
        }
    }

    //has to be overridden
    public mapToDto(): IModelDto {
        return {};
    }

}
